import React from "react";
import { useAppSelector } from "../../store/hooks";

import StakeNumber from "./StakeNumber";
import ColorBoard from "./ColorBoard";
import ParityBoard from "./ParityBoard";

const BettingBoard: React.FC = () => {
  const colorStakeMultipliers = useAppSelector(
    (state) => state.config.colorStakeMultipliers
  );
  const numberStakeMultipliers = useAppSelector(
    (state) => state.config.numberStakeMultipliers
  );
  const parityStakeMultipliers = useAppSelector(
    (state) => state.config.parityStakeMultipliers
  );

  return (
    <div className="panel_box">
      <div className="panel">
        <div className="number_panel">
          {colorStakeMultipliers.length > 0 && <ColorBoard />}

          <div className="single_number_row">
            <StakeNumber value="1" stakes={numberStakeMultipliers} />
            <StakeNumber value="2" stakes={numberStakeMultipliers} />
            <StakeNumber value="3" stakes={numberStakeMultipliers} />
          </div>

          <div className="single_number_row">
            <StakeNumber value="4" stakes={numberStakeMultipliers} />
            <StakeNumber value="5" stakes={numberStakeMultipliers} />
            <StakeNumber value="6" stakes={numberStakeMultipliers} />
          </div>

          <div className="single_number_row">
            <StakeNumber value="7" stakes={numberStakeMultipliers} />
            <StakeNumber value="8" stakes={numberStakeMultipliers} />
            <StakeNumber value="9" stakes={numberStakeMultipliers} />
          </div>

          <div className="single_number_row">
            <StakeNumber value="10" stakes={numberStakeMultipliers} />
            <StakeNumber value="11" stakes={numberStakeMultipliers} />
            <StakeNumber value="12" stakes={numberStakeMultipliers} />
          </div>

          {parityStakeMultipliers.length > 0 && <ParityBoard />}
        </div>
      </div>

      <div className="single_number_row">
        {colorStakeMultipliers.length === 0 && (
          <>
            <div className="single_number" />
            <StakeNumber value="0" stakes={numberStakeMultipliers} />
            <div className="single_number" />
          </>
        )}
      </div>
    </div>
  );
};

export default BettingBoard;
